export const getBridges = [
    { name: 'Net suite', updatedDate: '12-10-2021', status: true },
      { name: 'b', updatedDate: '12-09-2021', status: true },
      { name: 'c', updatedDate: '12-08-2021', status: true },
      { name: 'Data', updatedDate: '12-07-2021', status: true },

      { name: 'e', updatedDate: '12-06-2021', status: false },
      { name: 'f', updatedDate: '12-05-2021', status: false },
      { name: 'g', updatedDate: '12-04-2021', status: true },
      { name: 'h', updatedDate: '12-03-2021', status: true },
      { name: 'i', updatedDate: '12-02-2021', status: false },
      { name: 'j', updatedDate: '12-01-2021', status: true },
      { name: 'k', updatedDate: '12-10-2021', status: true },
      { name: 'l', updatedDate: '12-10-2021', status: true }
]

